export default {
  items: [
    {
      name: 'Exames Pendentes',
      url: '/dashboard',
      icon: 'icon-list'
    },

    {
      name: 'Pesquisa Avançada',
      url: '/examSearchClient',
      icon: 'icon-docs'
    },

    {
      name: 'Upload de Exame',
      url: '/examForm',
      icon: 'icon-cloud-upload'
    },

    {
      name: 'Logout',
      url: '/logout',
      icon: 'icon-lock'
    }
  ]
};



// WEBPACK FOOTER //
// ./src/components/Sidebar/_navClient.js